<template>
	
	<div style="width:780px;margin:0px auto 0 auto;padding:10px;">

        <div class="mb-2 d-flex">
            <el-form inline ref="searchform" :model="searchform">

               
                    <el-form-item class="mb-0">
                         <el-input :placeholder="$t('searchText.키워드')"  v-model="searchform.keyword" size="mini" style="width:200px" ></el-input>
                    </el-form-item>
                  
                    <el-form-item class="mb-0" >
                        <el-button type="info" size="mini" @click="searchQaEvent">{{$t('searchText.검색')}}</el-button>
                        <el-button type="success" size="mini" @click="editCon(false)">{{$t('tableText.추가')}}</el-button> 
                    </el-form-item>
            </el-form>
          
       
         
        
            
            
        </div>
           <el-table
                :data="autoQaContent"
                  :row-class-name="tableRowClassName1"
                  border
                style="width: 100%" v-loading="autoqaLoading" class="autoTable">
                <el-table-column
                  prop="title"
                   :label="$t('msg.제목')"
                 >
                   <template slot-scope="scope">{{scope.row.title}}</template>
                </el-table-column>
                
                <el-table-column
                  prop="add_time"
                   :label="$t('msg.등록일')" width="150">
                  
                </el-table-column>
              <el-table-column :label="$t('newAdd.관리')" align="center" class="mybuttonmini" width="150">
                             <template slot-scope="scope">
                            
                               
                                    <el-button type="primary" icon="el-icon-edit" size="mini" @click="editCon(scope)" style="padding:3px;">{{$t('msg.수정')}}</el-button>
                                
                                    <el-button type="danger" icon="el-icon-delete" size="mini" @click="del_qa_idx(scope.row.id)" plain  style="padding:3px;">{{$t('msg.삭제')}}</el-button>
                            
                          </template>
        </el-table-column>
              </el-table>
        
        
     <el-dialog
         :title="this.editIndex===-1 ? $t('tableText.추가') :$t('status.편집')"
          :visible.sync="autocreatModel" :close-on-click-modal ="false" :width="getW" :modal="modelFalse" top="5vh" class="quillDialog">

          <el-form ref="autoForm" :model="autoForm" label-width="70px" v-loading="autoloading" :rules="rules">
            
            <el-form-item :label="$t('searchText.키워드')"  prop="title2" class="mb-1">
              <el-input v-model="autoForm.title2" :placeholder="$t('searchText.리스트에노출될키워드')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('msg.제목')" prop="title" class="mb-1">
              <el-input v-model="autoForm.title" :placeholder="$t('msg.답변제목')"></el-input>
            </el-form-item>
           <el-form-item :label="$t('msg.내용')"  prop="contents" class="mb-1">
            <!--    <el-input
                type="textarea"
                :rows="12"
                v-model="form.contents" :placeholder="$t('msg.답변내용')">
              </el-input> -->
               <quill-editor 
                                v-model="autoForm.contents" 
                                ref="myQuillEditor" 
                                :options="editorOption" 
                                @blur="onEditorBlur($event)" 
                                @focus="onEditorFocus($event)"
                              @change="onEditorChange($event)">
                      </quill-editor>
                      <input type="file" @change="change" id="upload" style="display:none;" />
          </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
             <!-- <el-button @click="autocreatModel = false">{{$t('msg.취소')}}</el-button> -->
            <el-button type="primary" @click="autoSubmit">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>    

	</div>
</template>
<script>
 import { quillEditor, Quill  } from "vue-quill-editor";
Quill.register('modules/ImageExtend', ImageExtend)
import {ImageExtend, QuillWatch } from "quill-image-extend-module"
import "quill/dist/quill.core.css"; 
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
	export default{
     components: {
    
      quillEditor
    },
		props:{
		  info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
    
      layerid:{
        type:String,
        default:""
      },
		
		},
      created() {

       

          // this.info.id父组件传给子组件的id值
          
          this.fetchManage();

       
        
         
        
    },
		computed: {
         
            
        },
    	data(){
    		return{
           editorOption: {
           
            modules:{
            
              toolbar: {
                container:[
                     ['bold', 'italic', 'underline', 'strike'],  
                   
                     [{'list': 'ordered'}, {'list': 'bullet'}], 
                     ["image",'video','link'],
                     [{'color': []}, {'background': []}],
                    
                     [{'header': [1, 2, 3, 4, 5, 6, false]}],
                     
                ],
                 handlers: {
                    image(value) {
                      if (value) {
                        
                        document.querySelector('#upload').click()
                      } else {
                        this.quill.format('image', false)
                      }
                    },
                  },

              },
            },
             
            },
          editIndex:-1,
           modelFalse:false,
           getW:'600px',
        autoQaContent:[],
        autoForm:{
              title2:'',
              title:'',
              contents:'',
              id:'',
             },
        autoqaLoading:false,
        autoloading:false,
        autocreatModel:false,
          searchform:{
           keyword:'',
          },
         rules: {
                  
                  contents:[{ required: true, message: '', trigger: 'blur'}],
                   title2:[{ required: true, message: '', trigger: 'blur'}],
                    title:[{ required: true, message: '', trigger: 'blur'}],
                },
        
          
            domain:window.sessionStorage.getItem('domain'),
            userid:window.sessionStorage.getItem('userid'),
            sitetype:window.sessionStorage.getItem('sitetype'),
            aid:window.sessionStorage.getItem('admin_id'),
            power:window.sessionStorage.getItem('power'),
            rosing:window.sessionStorage.getItem('rosing'),
    			
    		}
    	},
       mounted() {
        
            
    },
    	methods:{
         
      
         fetchManage(){
           let token=window.sessionStorage.getItem('user');
             this.autoqaLoading = true
        
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/autoqalist?page=1'+'&title='+this.searchform.keyword,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 
             console.log('data====',response.data.data)
                  let item = response.data.data 
                  //this.form.content=''
                  this.autoQaContent = item.data
                 
                  this.autoqaLoading = false    
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
              
         },
          tableRowClassName1({row, rowIndex}) {
                 
                   if (rowIndex%2 === 1) {
                    return 'odd-row-class';
                   }
                   else{
                     return 'edd-row-class';
                   }
                },
           change(e) {
          let token=window.sessionStorage.getItem('user');
          let file = e.target.files[0]
          const formData = new FormData()
          formData.append('file', file)
          this.$axios({
　　　　　　　　　　url: this.domain+'/admin/fileu',
　　　　　　　　　　method: 'post',
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
　　　　　　　　　　data: formData,
　　　　　　　　　
　　　　　　　　}).then((url) => {
                    console.log('url:',url.data.data)
                     const quill = this.$refs.myQuillEditor.quill
                      quill.focus()
                      quill.insertEmbed(quill.getSelection().index, 'image', url.data.data)
                            　　　　　　　　　　
　　　　　　　　　
　　　　　　　　}).catch(err => {
          console.error(err)
        })

    
    },
         searchQaEvent(){

                if(this.searchform.keyword==''){
                    this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                     return;
                }
                this.fetchManage();
                
             

            },
             onEditorReady(editor) { // 准备编辑器
        },
          onEditorBlur(){}, // 失去焦点事件
          onEditorFocus(){}, // 获得焦点事件
          onEditorChange(event){
              // console.log(event.html)
               // this.form.admin_contents = event.html
          }, 
              autoSubmit(){
              let token=window.sessionStorage.getItem('user');
              this.$refs.autoForm.validate((e)=>{
             if(!e) return;
          
             //添加提交
              if (this.editIndex === -1) {
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/autoqa_add',
                        data:{
                          contents:this.autoForm.contents,
                          id:this.autoForm.id,
                          title:this.autoForm.title,
                          title2:this.autoForm.title2
                          
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message({
                                message:'완료',
                                type:'success'
                               });
                               //console.log(this.form);
                               this.fetchManage();
                               //this.tableData.unshift(this.form)
                               //关闭
                           this.autocreatModel = false

                            }
                           this.autoloading =false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
              
            }else{
              
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/autoqa_up',
                      data:{
                          id:this.autoForm.id,
                          contents:this.autoForm.contents,
                          title:this.autoForm.title,
                          title2:this.autoForm.title2
                         
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                   if(response.data.code==200){
                       this.autocreatModel = false
                       this.$message({
                           message:this.$i18n.t("msg.수정완료"),
                          type:'success'
                      })   
                    }else
                    {
                      
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    this.fetchManage()
                     this.autocreatModel = false
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })

            }
            })
              
            
        },
            editCon(e = false){
          let token=window.sessionStorage.getItem('user');
          //tianjia
          if(!e){
            this.autoForm = {
                contents:'',
                title:'',
                title2:''
                 }
             this.editIndex = -1

          }
          else{
             //修改
            this.autoloading = true
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/autoqa_id?id='+e.row.id,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
                 this.autoloading = false
                  let item = response.data.data
                  console.log('data==',item)
                  
                    this.autoForm = {
                          title:item.title,
                          contents:item.contents,
                          id:item.id,
                          title2:item.title2

                }
                this.editIndex = e.$index
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })


          }
        
          this.autocreatModel = true
         
        },
        del_qa_idx(id){
    
        

        this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {


           let token=window.sessionStorage.getItem('user');
                 this.$axios({
                        method:'post',
                        url:this.domain+'/admin/autoqa_del',
                        data:{
                          idx:[id],     
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                               message:response.data.msg,
                                type: 'warning'
                               });
                            }else{
                               this.$message({
                                message:response.data.msg,
                                type:'success'
                               });

                                  this.fetchManage();
                            }
                         
                     
                  }).catch((error) =>{
                      
                  })
                  

           }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨")
          });          
        });


           
          
         },
        
         

       
    	
    	}
	}
</script>
<style>
.ql-toolbar.ql-snow + .ql-container.ql-snow{
  height:150px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/auto-dialog.vue